if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener(
        'on:debounced-resize',
        this.resizeHandler
      );

      if (this.resizeInitHandler) {
        window.removeEventListener(
          'on:debounced-resize',
          this.resizeInitHandler
        );
      }

      if (this.zoomInitHandler) {
        window.removeEventListener(
          'on:debounced-resize',
          this.zoomInitHandler
        );
      }
    }

    init() {
      this.section = this.closest('.js-product');

      if (!this.section) return;

      this.noSelectedVariant = this.hasAttribute(
        'data-no-selected-variant'
      );

      this.mediaGroupingEnabled =
        this.hasAttribute('data-media-grouping-enabled')
        && this.getMediaGroupData();

      this.stackedScroll = this.dataset.stackedScroll;

      this.stackedUnderline =
        this.dataset.stackedUnderline === 'true'
        && !this.mediaGroupingEnabled;

      this.isFeatured = this.dataset.isFeatured === 'true';

      this.viewer = this.querySelector('.media-viewer');
      this.thumbs = this.querySelector('.media-thumbs');

      this.viewerItems = this.querySelectorAll(
        '.media-viewer__item'
      );

      this.thumbsItems = this.querySelectorAll(
        '.media-thumbs__item'
      );

      this.controls = this.querySelector('.media-ctrl');

      this.prevBtn = this.querySelector(
        '.media-ctrl__btn[name="prev"]'
      );

      this.nextBtn = this.querySelector(
        '.media-ctrl__btn[name="next"]'
      );

      this.counterCurrent = this.querySelector(
        '.media-ctrl__current-item'
      );

      this.counterTotal = this.querySelector(
        '.media-ctrl__total-items'
      );

      this.liveRegion = this.querySelector(
        '.media-gallery__status'
      );

      this.zoomLinks = this.querySelectorAll('.js-zoom-link');

      this.loadingSpinner = this.querySelector(
        '.loading-spinner'
      );

      this.xrButton = this.querySelector(
        '.media-xr-button'
      );

      if (!this.viewer) return;

      if (this.hasAttribute('data-zoom-enabled')) {
        const zoomTemplate = this.querySelector(
          '.js-media-zoom-template'
        );

        if (zoomTemplate) {
          this.galleryModal =
            zoomTemplate.content.firstElementChild.cloneNode(true);
        }
      }

      /*
       * The first five product images are always treated as
       * shared mother images.
       *
       * On initial load:
       * Show only images 1–5.
       *
       * After selecting a colour:
       * Show images 1–5 plus the selected variant image.
       */
      if (this.mediaGroupingEnabled) {
        if (this.noSelectedVariant) {
          this.setActiveMediaGroup(null, true);
        } else {
          this.setActiveMediaGroup(
            this.getMediaGroupFromOptionSelectors()
          );
        }
      }

      if (
        this.dataset.layout === 'stacked'
        && theme.mediaMatches.md
      ) {
        this.resizeInitHandler =
          this.resizeInitHandler
          || this.initGallery.bind(this);

        window.addEventListener(
          'on:debounced-resize',
          this.resizeInitHandler
        );

        this.setVisibleItems();

        this.previousMediaItem =
          this.visibleItems[0]
          || this.querySelector(
            '.media-viewer__item.is-current-variant'
          );

        if (this.previousMediaItem) {
          setTimeout(() => {
            this.customSetActiveMedia(
              this.previousMediaItem,
              this.stackedScroll === 'always'
            );
          }, 200);
        }
      } else {
        this.initGallery();
      }

      if (this.zoomLinks.length > 0) {
        if (this.dataset.zoomTrigger === 'hover') {
          this.triggerZoomInit();
        } else {
          this.zoomLinks.forEach((zoomLink) => {
            zoomLink.addEventListener('click', (evt) => {
              this.triggerZoomInit();
              evt.preventDefault();
            });
          });
        }
      }

      this.section.addEventListener(
        'on:variant:change',
        this.onVariantChange.bind(this)
      );
    }

    triggerZoomInit() {
      this.zoomInitHandler =
        this.zoomInitHandler
        || this.initZoom.bind(this);

      this.zoomEventListener =
        this.zoomEventListener
        || this.handleZoomMouseMove.bind(this);

      window.addEventListener(
        'on:debounced-resize',
        this.zoomInitHandler
      );

      this.initZoom();

      this.zoomLinks.forEach((zoomLink) => {
        zoomLink.addEventListener('click', (evt) => {
          evt.preventDefault();
        });
      });
    }

    /**
     * Runs when the selected product variant changes.
     */
    onVariantChange(evt) {
      if (this.mediaGroupingEnabled) {
        const groupName =
          this.getMediaGroupFromOptionSelectors();

  this.setActiveMediaGroup(groupName, false);
}

      if (
        evt.detail.variant
        && evt.detail.variant.featured_media
      ) {
        const variantMedia = this.viewer.querySelector(
          `[data-media-id="${evt.detail.variant.featured_media.id}"]`
        );

        if (
          variantMedia
          && variantMedia.style.display !== 'none'
        ) {
          this.customSetActiveMedia(
            variantMedia,
            true
          );
        }
      }
    }

    /**
     * Gets the selected colour name from the option selector.
     */
    getMediaGroupFromOptionSelectors() {
      const groupData = this.getMediaGroupData();

      if (!groupData) return null;

      const optionSelectors =
        this.section.querySelectorAll('.option-selector');

      if (
        optionSelectors.length
        <= groupData.groupOptionIndex
      ) {
        return null;
      }

      const selector =
        optionSelectors[groupData.groupOptionIndex];

      if (!selector) return null;

      if (selector.dataset.selectorType === 'dropdown') {
        const dropdownButton = selector.querySelector(
          '.custom-select__btn'
        );

        return dropdownButton
          ? dropdownButton.textContent.trim()
          : null;
      }

      const checkedInput = selector.querySelector(
        'input:checked'
      );

      return checkedInput
        ? checkedInput.value
        : null;
    }

    /**
     * Reads Enterprise's variant media data.
     */
    getMediaGroupData() {
      if (typeof this.variantMediaData === 'undefined') {
        const dataElement = this.querySelector(
          '.js-data-variant-media'
        );

        try {
          this.variantMediaData = dataElement
            ? JSON.parse(dataElement.textContent)
            : false;
        } catch (error) {
          console.error(
            'Unable to read variant media data:',
            error
          );

          this.variantMediaData = false;
        }
      }

      return this.variantMediaData;
    }

    /**
     * Builds the shared images and colour image groups.
     *
     * The first five media items are always shared.
     * Every media item after the first five must be assigned
     * as a Shopify variant image.
     */
    getMediaGroupMap() {
      if (this.mediaGroupMap) {
        return this.mediaGroupMap;
      }

      this.mediaGroupMap = {
        groups: {},
        sharedItems: []
      };

      const variantMediaData = this.getMediaGroupData();

      if (
        !variantMediaData
        || !Array.isArray(variantMediaData.variantMedia)
      ) {
        return this.mediaGroupMap;
      }

      this.viewerItems = this.querySelectorAll(
        '.media-viewer__item'
      );

      this.viewerItems.forEach((item, index) => {
        const groupItem = {
          main: item,
          thumb: null
        };

        if (this.thumbs) {
          groupItem.thumb = this.thumbs.querySelector(
            `.media-thumbs__item[data-media-id="${item.dataset.mediaId}"]`
          );
        }

        /*
         * Images 1 to 5 are the permanent mother images.
         */
        if (index < 7) {
          this.mediaGroupMap.sharedItems.push(groupItem);
          return;
        }

        const mediaId = parseInt(
          item.dataset.mediaId,
          10
        );

        const matchingMedia =
          variantMediaData.variantMedia.find(
            (mediaData) => (
              Number(mediaData.mediaId) === mediaId
              && mediaData.option
            )
          );

        /*
         * Hide any image after image 5 unless it is assigned
         * to a Shopify colour variant.
         */
        if (!matchingMedia) return;

        const optionName =
          String(matchingMedia.option).trim();

        if (!this.mediaGroupMap.groups[optionName]) {
          this.mediaGroupMap.groups[optionName] = {
            name: optionName,
            items: []
          };
        }

        this.mediaGroupMap.groups[optionName].items.push(
          groupItem
        );
      });

      this.mediaGroupMap.groupFromItem = (item) => {
        if (!item) return null;

        const groupNames = Object.keys(
          this.mediaGroupMap.groups
        );

        for (
          let groupIndex = 0;
          groupIndex < groupNames.length;
          groupIndex += 1
        ) {
          const group =
            this.mediaGroupMap.groups[
              groupNames[groupIndex]
            ];

          for (
            let itemIndex = 0;
            itemIndex < group.items.length;
            itemIndex += 1
          ) {
            if (
              group.items[itemIndex].main === item
            ) {
              return group;
            }
          }
        }

        return null;
      };

      return this.mediaGroupMap;
    }

    /**
     * Shows the five mother images and, when selected,
     * the current colour variant image.
     */
    setActiveMediaGroup(
      groupName,
      sharedOnly = false
    ) {
      const mediaGroupMap =
        this.getMediaGroupMap();

      let selectedGroup = null;

      if (!sharedOnly && groupName) {
        const normalisedGroupName =
          String(groupName).trim().toLowerCase();

        const matchingKey = Object.keys(
          mediaGroupMap.groups
        ).find(
          (key) => (
            key.trim().toLowerCase()
            === normalisedGroupName
          )
        );

        if (matchingKey) {
          selectedGroup =
            mediaGroupMap.groups[matchingKey];
        }
      }

      this.currentGroup = selectedGroup;

      /*
       * First hide absolutely every image and thumbnail.
       */
      this.viewerItems.forEach((item) => {
        item.style.display = 'none';

        item.classList.remove(
          'media-viewer__item--single'
        );
      });

      this.thumbsItems.forEach((item) => {
        item.style.display = 'none';
      });

      /*
       * Always restore the first five mother images.
       */
      mediaGroupMap.sharedItems.forEach((item) => {
        item.main.style.display = '';

        if (item.thumb) {
          item.thumb.style.display = '';
        }
      });

      /*
       * Restore only the selected colour's image.
       */
      if (selectedGroup) {
        selectedGroup.items.forEach((item) => {
          item.main.style.display = '';

          if (item.thumb) {
            item.thumb.style.display = '';
          }
        });
      }

      this.setVisibleItems();

      if (this.visibleItems.length === 0) return;

      const currentItemIsVisible =
        this.currentItem
        && this.currentItem.style.display !== 'none'
        && this.visibleItems.includes(this.currentItem);

      /*
       * Keep the current mother image active where possible.
       * Otherwise return to the first mother image.
       */
      if (!currentItemIsVisible) {
        this.customSetActiveMedia(
          this.visibleItems[0],
          false
        );
      } else {
        this.currentIndex =
          this.visibleItems.indexOf(this.currentItem);

        this.updateGalleryControls();
      }

      if (this.visibleItems.length === 1) {
        this.visibleItems[0].classList.add(
          'media-viewer__item--single'
        );
      }
    }

    /**
     * Initialises the gallery slider.
     */
    initGallery() {
      this.setVisibleItems();

      if (this.visibleItems.length === 0) return;

   this.currentItem = this.visibleItems[0];
this.currentIndex = 0;

      this.currentIndex =
        this.visibleItems.indexOf(this.currentItem);

      if (this.visibleItems.length > 1) {
        this.viewerItemOffset =
          this.visibleItems[1].offsetLeft
          - this.visibleItems[0].offsetLeft;

        this.addListeners();
      }

      if (this.thumbs && this.currentItem) {
        this.currentThumb =
          this.thumbs.querySelector(
            `.media-thumbs__item[data-media-id="${this.currentItem.dataset.mediaId}"]`
          );
      }

      if (
        !this.isFeatured
        && document.hasFocus()
      ) {
        this.viewer
          .querySelectorAll(
            '.product-image[loading="lazy"]'
          )
          .forEach((image, index) => {
            setTimeout(() => {
              image.loading = 'eager';
            }, 500 * (index + 1));
          });
      }

      this.customSetActiveMedia(
        this.currentItem,
        false,
        true
      );
    }

    addListeners() {
      if (!this.listenersAdded) {
        this.viewer.addEventListener(
          'scroll',
          this.handleScroll.bind(this)
        );

        if (this.controls) {
          this.controls.addEventListener(
            'click',
            this.handleNavClick.bind(this)
          );
        }

        if (this.thumbs) {
          this.thumbs.addEventListener(
            'click',
            this.handleThumbClick.bind(this)
          );
        }

        this.listenersAdded = true;
      }

      this.resizeHandler =
        this.resizeHandler
        || this.handleResize.bind(this);

      window.addEventListener(
        'on:debounced-resize',
        this.resizeHandler
      );
    }

    /**
     * Initialises image zoom.
     */
    initZoom() {
      this.zoomLinks.forEach((element) => {
        const zoomImage = element.querySelector(
          '.zoom-image'
        );

        const productImage = element.querySelector(
          '.product-image'
        );

        if (!zoomImage || !productImage) return;

        const zoomWidth = Number(
          zoomImage.dataset.originalWidth || 0
        );

        const imageWidth =
          productImage.getBoundingClientRect().width;

        if (
          theme.mediaMatches.md
          && zoomWidth - 75 > imageWidth
        ) {
          element.addEventListener(
            'mousemove',
            this.zoomEventListener
          );

          element.classList.remove(
            'pointer-events-none'
          );
        } else {
          element.removeEventListener(
            'mousemove',
            this.zoomEventListener
          );

          element.classList.add(
            'pointer-events-none'
          );
        }
      });
    }

    /**
     * Handles mouse movement over zoomable images.
     */
    handleZoomMouseMove(evt) {
      if (
        this.hasAttribute('data-zoom-enabled')
        && !this.dataset.zoomTrigger
        && !evt.target.closest('.gallery-zoom-modal')
      ) {
        return;
      }

      const hoverElement = evt.currentTarget;

      const zoomImage = hoverElement.querySelector(
        '.js-zoom-image'
      );

      if (!zoomImage) return;

      if (zoomImage.dataset.src) {
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove(
            'loading-spinner--out'
          );
        }

        const image = new Image();
        image.src = zoomImage.dataset.src;

        image.onload = () => {
          zoomImage.src = image.src;

          hoverElement.classList.remove(
            'media--zoom-not-loaded'
          );

          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add(
              'loading-spinner--out'
            );
          }
        };

        zoomImage.removeAttribute('data-src');
      }

      try {
        const offsetX = evt.offsetX
          ? evt.offsetX
          : evt.touches[0].pageX;

        const offsetY = evt.offsetY
          ? evt.offsetY
          : evt.touches[0].pageY;

        const x =
          (offsetX / zoomImage.offsetWidth) * 100;

        const y =
          (offsetY / zoomImage.offsetHeight) * 100;

        zoomImage.style.objectPosition =
          `${x}% ${y}%`;
      } catch (error) {
        // Fail silently.
      }
    }

    /**
     * Handles gallery scrolling.
     */
    handleScroll() {
  if (
        !this.viewerItemOffset
    || this.visibleItems.length < 2
  ) {
    return;
  }

      const newIndex = Math.round(
        this.viewer.scrollLeft
        / this.viewerItemOffset
      );

      if (
        newIndex !== this.currentIndex
        && this.visibleItems[newIndex]
      ) {
        const viewerItemOffset =
          this.visibleItems[1].offsetLeft
          - this.visibleItems[0].offsetLeft;

        if (
          viewerItemOffset
          === this.viewerItemOffset
        ) {
          this.customSetActiveMedia(
            this.visibleItems[newIndex],
            false
          );
}
      }
    }

    /**
     * Handles previous and next buttons.
     */
 handleNavClick(evt) {
      const button = evt.target.closest(
        '.media-ctrl__btn'
      );

  if (!button) return;

      let itemToShow = null;

  if (button === this.nextBtn) {
        itemToShow =
          this.visibleItems[this.currentIndex + 1];
  } else {
        itemToShow =
          this.visibleItems[this.currentIndex - 1];
      }

  if (!itemToShow) return;

  /*
   * Set the index directly instead of waiting for the
   * scroll event to calculate it incorrectly.
   */
  this.currentIndex = newIndex;
  this.currentItem = itemToShow;

  if (this.viewer) {
    this.viewer.scrollTo({
      left: itemToShow.offsetLeft,
      behavior: 'smooth'
    });
  }

  if (this.thumbs) {
    this.setActiveThumb();
  }

  this.updateGalleryControls();

  this.announceLiveRegion(
    itemToShow,
    newIndex + 1
  );

  MediaGallery.playActiveMedia(itemToShow);
}
    /**
     * Handles thumbnail clicks.
     */
    handleThumbClick(evt) {
      const thumb = evt.target.closest(
        '[data-media-id]'
      );

      if (!thumb) return;

      const itemToShow =
        this.viewer.querySelector(
          `.media-viewer__item[data-media-id="${thumb.dataset.mediaId}"]`
        );

      if (
        !itemToShow
        || itemToShow.style.display === 'none'
      ) {
        return;
      }

      this.customSetActiveMedia(itemToShow);

      MediaGallery.playActiveMedia(itemToShow);
    }

    /**
     * Handles browser resizing.
     */
    handleResize() {
      this.setVisibleItems();

      if (this.visibleItems.length > 1) {
        this.viewerItemOffset =
          this.visibleItems[1].offsetLeft
          - this.visibleItems[0].offsetLeft;
      }

      if (
        this.thumbs
        && this.currentThumb
      ) {
        this.checkThumbVisibilty(
          this.currentThumb
        );
      }
    }

    /**
     * Stub used by the variant picker.
     */
    setActiveMedia() {}

    /**
     * Sets the currently active gallery image.
     */
    customSetActiveMedia(
      mediaItem,
      scrollToItem = true,
      forceUpdate = false
    ) {
      if (!mediaItem) return;

      if (
        mediaItem.style.display === 'none'
        || !this.visibleItems.includes(mediaItem)
      ) {
        mediaItem =
          this.visibleItems[0] || null;
      }

      if (!mediaItem) return;

      if (
        mediaItem === this.currentItem
        && !forceUpdate
      ) {
        this.updateGalleryControls();
        return;
      }

      window.pauseAllMedia(this);

      this.currentItem = mediaItem;

      this.currentIndex =
        this.visibleItems.indexOf(
          this.currentItem
        );

      if (this.currentIndex < 0) {
        this.currentIndex = 0;

        this.currentItem =
          this.visibleItems[0];
      }

      if (
        this.dataset.layout === 'stacked'
        && theme.mediaMatches.md
      ) {
        if (this.stackedUnderline) {
          if (this.previousMediaItem) {
            this.previousMediaItem.classList.remove(
              'is-active'
            );
          }

          this.currentItem.classList.add(
            'is-active'
          );

          this.previousMediaItem =
            this.currentItem;
        }

        if (
          scrollToItem
          && this.stackedScroll !== 'never'
        ) {
          const y =
            this.currentItem
              .getBoundingClientRect().top
            + document.documentElement.scrollTop
            - 150;

          if (
            Math.abs(
              y
              - document.documentElement.scrollTop
            ) > 300
          ) {
            window.scrollTo({
              top: y < 100 ? 0 : y,
              behavior: 'smooth'
            });
          }
        }

        return;
      }

      if (scrollToItem) {
        this.viewer.scrollTo({
          left: this.currentItem.offsetLeft,
          behavior: 'auto'
        });
      }

      if (this.thumbs) {
        this.setActiveThumb();
      }

      this.updateGalleryControls();

      this.announceLiveRegion(
        this.currentItem,
        this.currentIndex + 1
      );

      if (
        this.xrButton
        && this.currentItem.dataset.mediaType
          === 'model'
      ) {
        this.xrButton.dataset.shopifyModel3dId =
          this.currentItem.dataset.mediaId;
      }
    }

    /**
     * Updates arrows and image counters.
     */
    updateGalleryControls() {
      if (this.prevBtn) {
        this.prevBtn.disabled =
          this.currentIndex <= 0;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled =
          this.currentIndex
          >= this.visibleItems.length - 1;
      }

      if (this.counterCurrent) {
        this.counterCurrent.textContent =
          this.currentIndex + 1;
      }

      if (this.counterTotal) {
        this.counterTotal.textContent =
          this.visibleItems.length;
      }
    }

    /**
     * Sets the selected thumbnail.
     */
    setActiveThumb() {
      if (
        !this.thumbs
        || !this.currentItem
      ) {
        return;
      }

      this.currentThumb =
        this.thumbs.querySelector(
          `.media-thumbs__item[data-media-id="${this.currentItem.dataset.mediaId}"]`
        );

      this.thumbs
        .querySelectorAll(
          '.media-thumbs__btn'
        )
        .forEach((element) => {
          element.classList.remove(
            'is-active'
          );

          element.removeAttribute(
            'aria-current'
          );
        });

      if (!this.currentThumb) return;

      const button =
        this.currentThumb.querySelector(
          'button'
        );

      if (!button) return;

      button.classList.add('is-active');
      button.setAttribute(
        'aria-current',
        'true'
      );

      this.checkThumbVisibilty(
        this.currentThumb
      );
    }

    /**
     * Creates a list of currently visible images.
     */
    setVisibleItems() {
      this.viewerItems =
        this.querySelectorAll(
          '.media-viewer__item'
        );

      this.visibleItems =
        Array.from(this.viewerItems).filter(
          (element) => (
            element.style.display !== 'none'
            && element.getClientRects().length > 0
          )
        );

      if (this.counterTotal) {
        this.counterTotal.textContent =
          this.visibleItems.length;
      }
    }

    /**
     * Keeps the selected thumbnail visible.
     */
    checkThumbVisibilty(thumb) {
      if (!this.thumbs || !thumb) return;

      const scrollPosition =
        this.thumbs.scrollLeft;

      const lastVisibleThumbOffset =
        this.thumbs.clientWidth
        + scrollPosition;

      const thumbOffset =
        thumb.offsetLeft;

      if (
        thumbOffset + thumb.clientWidth
          > lastVisibleThumbOffset
        || thumbOffset < scrollPosition
      ) {
        this.thumbs.scrollTo({
          left: thumbOffset,
          behavior: 'smooth'
        });
      }
    }

    /**
     * Announces the selected image for screen readers.
     */
    announceLiveRegion(mediaItem, index) {
      if (
        !mediaItem
        || !this.liveRegion
      ) {
        return;
      }

      const image = mediaItem.querySelector(
        '.media-viewer img, img'
      );

      if (!image) return;

      this.liveRegion.setAttribute(
        'aria-hidden',
        'false'
      );

      this.liveRegion.innerHTML =
        theme.strings.imageAvailable.replace(
          '[index]',
          index
        );

      setTimeout(() => {
        this.liveRegion.setAttribute(
          'aria-hidden',
          'true'
        );
      }, 2000);
    }

    /**
     * Loads video or 3D media when selected.
     */
    static playActiveMedia(mediaItem) {
      if (!mediaItem) return;

      window.pauseAllMedia();

      const deferredMedia =
        mediaItem.querySelector(
          'deferred-media'
        );

      if (deferredMedia) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define(
    'media-gallery',
    MediaGallery
  );
}customElements.define('media-gallery', MediaGallery);